import baseHttp from './baseHttp';

// Partner operational controls (busy mode / pause orders / emergency open-close).
// action: pause | resume | busy | unbusy | open | close | follow_schedule
const setStatus = (restaurantId, action, params = {}) =>
  baseHttp
    .post(`/api/v1/restaurants/${restaurantId}/operational-status`, { action, ...params })
    .then((r) => r.data);

export const pauseOrders   = (restaurantId, minutes) => setStatus(restaurantId, 'pause', minutes ? { minutes } : {});
export const resumeOrders  = (restaurantId)          => setStatus(restaurantId, 'resume');
export const setBusy       = (restaurantId, minutes, extra_minutes) => setStatus(restaurantId, 'busy', { minutes, extra_minutes });
export const clearBusy     = (restaurantId)          => setStatus(restaurantId, 'unbusy');
export const openNow       = (restaurantId, minutes) => setStatus(restaurantId, 'open', minutes ? { minutes } : {});
export const closeNow      = (restaurantId, minutes) => setStatus(restaurantId, 'close', minutes ? { minutes } : {});
export const followSchedule = (restaurantId)         => setStatus(restaurantId, 'follow_schedule');
